import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfessionalsService } from '@app/_services';
import { Subject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { RatingModule } from 'ngx-bootstrap/rating';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-professional-review-dialog',
    templateUrl: './professional-review-dialog.component.html',
    styleUrls: ['./professional-review-dialog.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, FlexModule, RatingModule, TranslateModule]
})
export class ProfessionalReviewDialogComponent implements OnInit {

    constructor(
        private fb: UntypedFormBuilder,
        public bsModalRef: BsModalRef,
        private toastr: ToastrService,
        private professionalsService: ProfessionalsService
    ) { }

    public onClose: Subject<boolean>;
    form = this.fb.group({
        name: ['', Validators.required],
        rating: [1, Validators.required],
        review: [''],
    });
    userDetails;
    professionalSlug;

    ngOnInit(): void {
        this.onClose = new Subject();
        if (this.userDetails) {
            this.name.setValue(this.userDetails?.name);
        }
    }

    save() {
        this.professionalsService.submitReview(this.professionalSlug, this.form.value).subscribe(response => {
            if (response?.code == 200) {
                this.toastr.success(response.msg);
                this.onClose.next(true);
                this.bsModalRef.hide();
            } else {
                this.toastr.error(response?.msg);
            }
        });
    }

    get name() {
        return this.form.get('name');
    }

}
